module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-mask-11.35798f0d.png";